import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './diary-list.module.css';
import arrowImage from '../../images/back.svg';
import { draftsLabel } from '../../helpers/daily-records-helper';

const DiaryList: FC<{ diaries: ClassroomDiaryCount[] }> = ({ diaries }) => {
  const renderDiaries = () => {
    const diariesElements = [];

    diaries.forEach((diary) => {
      const allDone = diary.pending === 0;
      const drafts = draftsLabel(diary.drafts);
      const draftsElement = drafts && <span className={styles.drafts}> · {drafts}</span>;
      const allDoneElement = (
        <p className={styles.diaryTitleSmall}>Todos feitos{draftsElement}</p>
      );
      const remainElement = (
        <p className={styles.diaryTitleSmall}>
          Faltam <span>{diary.pending}</span> de {diary.total}
          {draftsElement}
        </p>
      );
      const allDoneArrowClass = allDone
        ? styles.arrowContainerDone
        : styles.arrowContainerRemain;

      diariesElements.push(
        <Link to={`/diarios/turma/${diary.classroomUuid}`} key={diary.classroomUuid}>
          <div className={`${styles.displayGridItem} shadow-box`}>
            <div className={styles.diaryTitle}>
              <p className={styles.diaryTitleBig}>{diary.classroomName} -</p>
              {allDone ? allDoneElement : remainElement}
            </div>
            <div className={allDoneArrowClass}>
              <img
                src={arrowImage}
                alt='Ir para diário'
                title='Ir para diário'
              />
            </div>
          </div>
        </Link>
      );
    });

    return diariesElements;
  };

  if (!diaries) return null;

  return (
    <div className={styles.diariesContainer}>
      <h3>Diários de hoje - {new Date().toLocaleDateString('pt-br')}</h3>
      <div className={styles.diariesGrid}>{renderDiaries()}</div>
    </div>
  );
};

export default DiaryList;
